export {default} from './EmailCapture';
